export default class ColumnHeaderElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('column-header', ColumnHeaderElement);